import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'hideText',
})
export class HideTextPipe implements PipeTransform {
    transform(value?: string, hide: boolean = true): string {
        // @ts-ignore
        return hide ? value?.replace(/[a-zA-Z0-9]/g, '*') : value
    }
}
